import { ManageResourcePermissionRequestBuilder } from "./ManageResourcePermissionRequestBuilder";
import { RevokeResourcePermissionRequestBuilder } from "./RevokeResourcePermissionRequestBuilder";

export class RevokeResourcePermissionRequestBuilderFactory {
    private static readonly INSTANCE: ManageResourcePermissionRequestBuilder = new RevokeResourcePermissionRequestBuilder();
    public static getInstance(): ManageResourcePermissionRequestBuilder {
        return this.INSTANCE;
    }
}